module.exports = __webpack_public_path__ + "static/media/11-ungdomsskole.d211f581.mp3";